import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/page_about_recycling.webp'
import _imports_1 from '../images/mobile_page_about_recycling_1.webp'
import _imports_2 from '../images/mobile_page_about_recycling_2.webp'


const _withScopeId = n => (_pushScopeId("data-v-0d4c8eaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tetrapak-page-about-recycling" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content1 d-none d-md-block\" data-v-0d4c8eaf><img src=\"" + _imports_0 + "\" alt=\"\" class=\"img-fluid\" data-v-0d4c8eaf></div><div class=\"content1 d-block d-md-none\" data-v-0d4c8eaf><img src=\"" + _imports_1 + "\" alt=\"\" class=\"img-fluid\" data-v-0d4c8eaf></div><div class=\"content2 d-block d-md-none mobile-x-scroll\" data-v-0d4c8eaf><img src=\"" + _imports_2 + "\" alt=\"\" class=\"img\" data-v-0d4c8eaf></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// TODO

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})